/* ===========
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file.
 */
import Audit from './audit';
import Backstage from './backstage';
import Base from './base';
import Business from './business';
import Visit from './visit';
import Compact from './compact';
import Customer from './customer';
import Statistics from './statistics';
import Clue from './clue';
import Knowledge from './knowledge';
import Project from './project';
import customRecycle from './customRecycle'
import NotFoundComponent from '../pages/base/404.vue';

Vue.use(VueRouter);

// 数组合并
const routes = [
  ...Audit,
  ...Backstage,
  ...Base,
  ...Business,
  ...Visit,
  ...Compact,
  ...Customer,
  ...Statistics,
  ...Clue,
  ...Knowledge,
  ...customRecycle,
  ...Project,
  {
    path: '*',
    component: NotFoundComponent,
    meta: { auth: true },
  },
];

const router = new VueRouter({
  mode: 'history',
  // base: '/static',
  routes,
});
// 重写路由的push方法
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

let authInitialized = false;

router.beforeEach(async (to, from, next) => {
  const matched = router.getMatchedComponents(to);

  function controller() {
    if (matched.length > 0) {
      if (!to.matched.some(m => m.meta.auth) && !store.state.authority.authenticated) {
        next({ path: '*' });
      }
      if (to.matched.some(m => m.meta.auth) && store.state.authority.authenticated) {
        next({ name: 'home' });
      } else {
        next();
      }
    }
  }

  if (matched.length > 0 && to.matched.some(m => m.meta.noAuth)) {
    next();
  } else if (!to.matched.some(m => m.path === '*')) {
    if (to.path !== '/') {
      await store.dispatch('authority/getUserInfo')
      await store.dispatch('authority/getAuthority', { menuUrl: to.path })
    }
    controller()
    authInitialized = true
    // store.dispatch('authority/getAuthority', { menuUrl: to.path })
    //   .then(() => {
    //     console.log('022333221212')
    //     // authInitialized = true;
    //     controller();
    //   }).finally(() => { authInitialized = true; });
  } else {
    controller();
  }
});

export default router;
